package com.example.hukakmp

class WebPlatform : Platform {
    override val name: String = "Web"
}

actual fun getPlatform(): Platform = WebPlatform()

actual val cameraCaptureAvailable: Boolean = false
actual val interactiveMapAvailable: Boolean = true
